import DataTable from "react-data-table-component";
import TableLoading from "../Loading/TableLoading";

function AttendanceCard({data, tableLoading, type}) {

        if(type === "all") { 
                const columnST = [
                {
                name: "EMPLOYEE",
                selector: row=>row.employeeName,
                sortable: true
                },
                {
                name: "DATE",
                selector: row=>row.date,
                sortable: true,
                },
                {
                name: "PUNCHIN TIME",
                selector: (row)=>row.punchInTime,
                sortable: true,
                }, 
                {
                name: "PUNCHOUT TIME",
                selector: (row)=><span className="text-danger">{row.punchOutTime}</span>,
                sortable: true,
                },
                {
                name: "BREAK TIME",
                selector: (row)=><span className="text-danger">{row.breakHours}</span>,
                sortable: true,
                },
                {
                name: "HALF DAY",
                selector: (row)=><i className={` ${row.halfDay === 'No'?'icofont-close-circled text-danger':'icofont-check-circled text-success'}`}></i>,
                sortable: true
                },
                {
                name: "FULL DAY",
                selector: (row)=><i className={` ${row.fullDay === 'No' ?'icofont-close-circled text-danger':'icofont-check-circled text-success'}`}></i>,
                sortable: true
                },
                {
                name: "OVERTIME",
                selector: (row)=><span className="text-success">{row.overtime}</span>,
                sortable: true,
                },
                {
                name: "TOTAL HOURS",
                selector: (row)=>row.totalHours
                }
        ];
                return ( 
                <div className="row clearfix g-3">
                        <div className="col-sm-12">
                        <DataTable
                                title=""
                                columns={columnST}
                                data={data?.data}
                                defaultSortField="title"
                                pagination
                                selectableRows={false}
                                className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                highlightOnHover={true}
                                progressPending={tableLoading}
                                progressComponent={<TableLoading row={10} col={7} width={160} height={20} />}
                        />
                        </div>
                </div>
        )

        }else {  
                return ( 
                <div className="card mb-3">
                        <div className="card-body">
                                <div className="atted-info d-flex mb-3 flex-wrap">
                                        <div className="full-present me-2">
                                                <i className="icofont-check-circled text-success me-1"></i>
                                                <span>Full Day Present</span>
                                        </div>
                                        <div className="Half-day me-2">
                                                <i className="icofont-wall-clock text-warning me-1"></i>
                                                <span>Half Day Present</span>
                                        </div>
                                        <div className="absent me-2">
                                                <i className="icofont-close-circled text-danger me-1"></i>
                                                <span>Full Day Absence</span>
                                        </div>
                                </div>
                                {
                                        (Array.isArray(data?.date_Array) && data?.date_Array.length) > 0 ? (
                                                <div className="table-responsive">
                                                        <table className="table table-hover align-middle mb-0" style={{ width: '100%' }}>
                                                                <thead>
                                                                        <tr>
                                                                                <th>Employee</th>
                                                                                {
                                                                                        Array.isArray(data?.date_Array) && data?.date_Array.map((val, key)=>(
                                                                                                <th>{val}</th>
                                                                                        ))
                                                                                } 
                                                                        </tr>
                                                                </thead>
                                                                <tbody>
                                                                        
                                                                                {
                                                                                        Array.isArray(data?.employee_Array) && data?.employee_Array.map((empid, key)=>(
                                                                                                <tr key={key}>
                                                                                                <td>
                                                                                                        
                                                                                                        <span className="fw-bold small">{data?.result_Array[key]?.employeeName}</span>
                                                                                                </td>
                                                                                                {
                                                                                                        data?.date_Array.map((datevalue, datekey)=>{
                                                                                                                
                                                                                                                const attendinfo = data?.result_Array[key]?.[empid][0]?.[datevalue][0] || {};
                                                                                                                return (
                                                                                                                <td key={datekey}> 
                                                                                                                        {attendinfo.fullDayPresent === "Yes" ? (
                                                                                                                        <i className="icofont-check-circled text-success"></i>
                                                                                                                        ) : attendinfo.halfDayPresent === "Yes" ? (
                                                                                                                        <i className="icofont-check-circled text-warning"></i>
                                                                                                                        ) : (
                                                                                                                        <i className="icofont-check-circled text-danger"></i>    
                                                                                                                        )} 
                                                                                                                </td>
                                                                                                                ); 
                                                                                                        })
                                                                                                }
                                                                                                </tr> 
                                                                                        ))
                                                                                }  
                                                                </tbody>
                                                        </table>
                                                </div>
                                        )
                                        : (
                                                <div className="table-responsive">
                                                        <table className="table table-hover align-middle mb-0" style={{ width: '100%' }}>
                                                                <td colSpan={5} className="textCenter">There are no records to display</td>
                                                        </table> 
                                                </div>
                                        )
                                }
                                
                        </div>
                </div>
        )
        }        
}


export default AttendanceCard;